import React from 'react';
import {
    Button as MuiButton,
    ButtonProps as MuiButtonProps,
} from '@mui/material';
import Icon from './Icon';

interface ButtonProps extends MuiButtonProps {
    children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
    children,
    startIcon,
    endIcon,
    ...props
}) => {
    const formatText = (text: React.ReactNode): React.ReactNode => {
        if (typeof text === 'string') {
            const trimmed = text.trim();
            return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
        }
        return text;
    };

    return (
        <MuiButton
            startIcon={<Icon iconName={startIcon} />}
            endIcon={<Icon iconName={endIcon} />}
            {...props}
        >
            {formatText(children)}
        </MuiButton>
    );
};

export default Button;
